
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "media",
  "title": "Media",
  "sidebar_label": "Media"
};
const slug = 'media';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p>{`A single media block API that serves multiple purpose. This block can be used for user generated content plus platform owners to host medias. `}</p>
    <p>{` You can use media API and it’s functionality in SuperAdmin to `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Upload images, PDF, Videos in Media Manager`}</li>
      <li parentName="ul">{`Re-use them in Promo Banner, Category Images, Listing Images, etc.`}</li>
      <li parentName="ul">{`Re-use in email templates and other markdown supported composers (Listings descriptions, etc)`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
